module.exports = __webpack_public_path__ + "assets/img/configuration-icon.ea19476e.svg";